import { platform } from "./platform";
import { initStorage } from "./storage";

export async function initStorageForPlatform() {
  if (platform.isDesktop) {
    const { ElectronStorageAdapter } = await import("./storage-electron");
    initStorage(new ElectronStorageAdapter());
    return;
  }

  const { WebStorageAdapter } = await import("./storage-web");
  initStorage(new WebStorageAdapter());
}
